import { db } from '../firebase/config';
import { doc, updateDoc, getDoc, serverTimestamp } from 'firebase/firestore';

export interface QRDesignData {
  qrColor: string;
  qrBackgroundColor: string;
  qrLogoUrl?: string;
  qrImageUrl?: string;
  qrValue: string;
  createdAt: any;
}

export class QRService {
  static async updateQRDesign(userId: string, cardId: string, designData: QRDesignData): Promise<void> {
    try {
      const cardRef = doc(db, 'users', userId, 'cards', cardId);
      
      // QR 디자인을 두 가지 형태로 저장
      // 1. qrDesign 객체 안에 저장 (웹에서 사용)
      // 2. 최상위 레벨에 저장 (Firebase Function에서 사용)
      await updateDoc(cardRef, {
        qrDesign: designData,
        // Firebase Function 호환성을 위한 최상위 레벨 저장
        qrColor: designData.qrColor,
        qrBackgroundColor: designData.qrBackgroundColor,
        qrLogoUrl: designData.qrLogoUrl,
        updatedAt: serverTimestamp()
      });
    } catch (error) {
      console.error('QR design update failed:', error);
      throw error;
    }
  }

  static async getQRDesign(userId: string, cardId: string): Promise<QRDesignData | null> {
    try {
      const cardRef = doc(db, 'users', userId, 'cards', cardId);
      const cardDoc = await getDoc(cardRef);
      
      if (cardDoc.exists()) {
        const data = cardDoc.data();
        // qrDesign 객체가 있으면 사용, 없으면 최상위 레벨 데이터 사용
        if (data.qrDesign) {
          return data.qrDesign;
        } else if (data.qrColor || data.qrBackgroundColor || data.qrLogoUrl) {
          // 최상위 레벨 데이터가 있으면 qrDesign 형태로 변환
          return {
            qrColor: data.qrColor || '#000000',
            qrBackgroundColor: data.qrBackgroundColor || '#FFFFFF',
            qrLogoUrl: data.qrLogoUrl,
            qrValue: data.qrValue || '',
            createdAt: data.createdAt || new Date()
          };
        }
      }
      return null;
    } catch (error) {
      console.error('QR design fetch failed:', error);
      throw error;
    }
  }

  // 기존 QR 디자인 데이터를 마이그레이션하는 함수
  static async migrateQRDesignData(userId: string, cardId: string): Promise<void> {
    try {
      const cardRef = doc(db, 'users', userId, 'cards', cardId);
      const cardDoc = await getDoc(cardRef);
      
      if (cardDoc.exists()) {
        const data = cardDoc.data();
        
        // qrDesign 객체가 없지만 최상위 레벨에 QR 데이터가 있는 경우
        if (!data.qrDesign && (data.qrColor || data.qrBackgroundColor || data.qrLogoUrl)) {
          const qrDesignData: QRDesignData = {
            qrColor: data.qrColor || '#000000',
            qrBackgroundColor: data.qrBackgroundColor || '#FFFFFF',
            qrLogoUrl: data.qrLogoUrl,
            qrValue: data.qrValue || '',
            createdAt: data.createdAt || new Date()
          };
          
          // qrDesign 객체로 마이그레이션
          await updateDoc(cardRef, {
            qrDesign: qrDesignData,
            updatedAt: serverTimestamp()
          });
          
          console.log('QR design data migrated for card:', cardId);
        }
      }
    } catch (error) {
      console.error('QR design migration failed:', error);
      throw error;
    }
  }
}